<template>
  <div id="table-broker">
    <v-chip
      :color="brokerColor"
      :small="small"
      :filter="filter"
      :value="value"
      :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }"
    >
      {{ broker.alias }}
    </v-chip>

    <span v-if="newBrokerAlias">
      <v-icon class="mx-1">mdi-arrow-right-bold</v-icon>
      <v-chip
        color="grey"
        small
        outlined
        :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }"
      >
        {{ newBrokerAlias }}
      </v-chip>
    </span>
  </div>
</template>

<script>
import predefinedBrokers from '@/lib/brokers/predefinedBrokers.json'

export default {
  props: {
    broker: {
      type: Object,
      required: true,
    },
    newBrokerAlias: {
      type: String,
      default: null,
    },
    small: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
      default: null,
    },
  },
  computed: {
    brokerColor() {
      const customColor = 'rgba(0,0,0,0.1)'
      if (this.broker.custom || !this.broker.code) return customColor

      const predefinedBroker = predefinedBrokers.brokers.find(
        (elem) => elem.code === this.broker.code
      )
      if (!predefinedBroker) return customColor

      if (!this.$vuetify.theme.dark) return predefinedBroker.color
      else return predefinedBroker.color.replace('0.1', '0.5')
    },
  },
}
</script>

<style lang="scss">
#table-broker {
  display: flex;
  align-items: center;
  margin-bottom: 1px;
}
</style>
